export default function removeA(content){
    return content.replace(/<a.*?>|<\/a>/g, "");
}